const center = "cui-center-a3s3";
const _classes = {
  center,
  "hide-visually": "cui-hide-visually-mb4x",
  "hide-scrollbar": "cui-hide-scrollbar-3dvz",
  "focus-visible": "cui-focus-visible-y4xg",
  "focus-visible-inset": "cui-focus-visible-inset-fa1m"
};
export {
  center,
  _classes as default
};
